// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

  --fontFamily: Roboto, sans-serif;
  --mainBackground: #fff;
  --dimBackground: #f9fafb;
  --mainForeground: #262626;
  --dimForeground: #6d7283;
  --primaryForeground: #315efb;
  --successForeground: #28bc00;
  --warningForeground: #f4c914;
  --failureForeground: #ff564e;
  --lightGrayBlue: #e8eaf0;
  --greyishBlue: #6674a6;
  --cloudGray: #8d96b2;
  --battleshipGrey: #62687f;
  --carbone: #343b4c;
}

.src-containers-Profile-Phones-styles--anchor--K61VR {
  color: #6674a6;
  color: var(--greyishBlue);
}

.src-containers-Profile-Phones-styles--anchor--K61VR:hover,.src-containers-Profile-Phones-styles--anchor--K61VR:focus {
    color: #315efb;
    color: var(--primaryForeground);
  }

@media screen and (min-width: 768px) {

.src-containers-Profile-Phones-styles--note--Am76g {
    max-width: 350px;
    vertical-align: top;
}
  }

.src-containers-Profile-Phones-styles--sberIcon--HtGJN {
  width: 15px !important;
  height: 15px !important;
}

.src-containers-Profile-Phones-styles--row--WTxFH {
  display: flex;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/utils/variables.css","webpack://./src/containers/Profile/Phones/styles.css"],"names":[],"mappings":"AAAA;;EAQE,gCAAgC;EAChC,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;ACpBA;EACE,cAAyB;EAAzB,yBAAyB;AAM3B;;AAJE;IAEE,cAA+B;IAA/B,+BAA+B;EACjC;;AAIA;;AADF;IAEI,gBAAgB;IAChB,mBAAmB;AAEvB;EADE;;AAGF;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[":root {\n  @custom-media --mobile screen and (width < 768px);\n  @custom-media --desktop screen and (width >= 768px);\n  @custom-media --desktop-l screen and (width >= 1024px);\n  @custom-media --desktop-x screen and (width >= 1280px);\n  @custom-media --desktop-xl screen and (width >= 1440px);\n  @custom-media --iphone screen and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 2);\n\n  --fontFamily: Roboto, sans-serif;\n  --mainBackground: #fff;\n  --dimBackground: #f9fafb;\n  --mainForeground: #262626;\n  --dimForeground: #6d7283;\n  --primaryForeground: #315efb;\n  --successForeground: #28bc00;\n  --warningForeground: #f4c914;\n  --failureForeground: #ff564e;\n  --lightGrayBlue: #e8eaf0;\n  --greyishBlue: #6674a6;\n  --cloudGray: #8d96b2;\n  --battleshipGrey: #62687f;\n  --carbone: #343b4c;\n}\n","@import 'utils/variables.css';\n\n.anchor {\n  color: var(--greyishBlue);\n\n  &:hover,\n  &:focus {\n    color: var(--primaryForeground);\n  }\n}\n\n.note {\n  @media (--desktop) {\n    max-width: 350px;\n    vertical-align: top;\n  }\n}\n\n.sberIcon {\n  width: 15px !important;\n  height: 15px !important;\n}\n\n.row {\n  display: flex;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"anchor": `src-containers-Profile-Phones-styles--anchor--K61VR`,
	"note": `src-containers-Profile-Phones-styles--note--Am76g`,
	"sberIcon": `src-containers-Profile-Phones-styles--sberIcon--HtGJN`,
	"row": `src-containers-Profile-Phones-styles--row--WTxFH`
};
module.exports = ___CSS_LOADER_EXPORT___;
